<template functional>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM13 18.5C13 19.3284 12.3284 20 11.5 20C10.6716 20 10 19.3284 10 18.5C10 17.6716 10.6716 17 11.5 17C12.3284 17 13 17.6716 13 18.5ZM13.3376 5.42225C12.8374 5.14277 12.2709 4.99689 11.6945 5.00005C11.118 5.00321 10.5532 5.15529 10.0563 5.44021C9.55956 5.72507 9.14862 6.13239 8.86313 6.62036C8.58424 7.09705 7.97172 7.25741 7.49503 6.97852C7.01833 6.69963 6.85798 6.0871 7.13687 5.61041C7.5999 4.81896 8.26388 4.16256 9.06148 3.70521C9.85899 3.2479 10.7629 3.00513 11.6835 3.00008C12.6041 2.99503 13.5107 3.22788 14.3132 3.67637C15.1159 4.12492 15.7871 4.77395 16.259 5.5602C16.7309 6.34655 16.9866 7.24219 16.9995 8.15793C17.0124 9.07366 16.782 9.97607 16.3323 10.7752C15.8827 11.5743 15.2298 12.2416 14.4399 12.712C14.3115 12.7885 14.1802 12.8594 14.0463 12.9245C13.1944 13.3391 12.7421 13.8903 12.7195 14.3722L12.6879 15.0468C12.662 15.5985 12.1938 16.0248 11.6421 15.9989C11.0905 15.973 10.6642 15.5048 10.6901 14.9532L10.7217 14.2785C10.7976 12.6603 12.1327 11.6315 13.1713 11.1261C13.2547 11.0855 13.3365 11.0414 13.4165 10.9938C13.9083 10.7008 14.3122 10.2869 14.5894 9.79437C14.8665 9.30196 15.0076 8.74754 14.9997 8.18608C14.9918 7.62462 14.8351 7.07417 14.5441 6.5894C14.2531 6.10453 13.8376 5.70169 13.3376 5.42225Z"
      fill="#71B0CF"
    />
  </svg>
</template>

<script>
export default {
  name: "UndefinedIcon"
};
</script>
